/**
 * Maps backend TransitionType enum values to frontend PlayerAction strings.
 * @module features/squad-planning/utils/mapTransitionToAction
 */

import type { PlayerAction } from "../types";

/** Backend enum → frontend action mapping. */
const TRANSITION_TYPE_MAP: Readonly<Record<string, PlayerAction>> = {
  SELL: "Sell",
  LOAN_OUT: "Loan",
  SIGN: "Sign",
  PROMOTE: "Promote",
};

/**
 * Converts a backend transitionType string to a PlayerAction.
 * @param transitionType - Backend enum value or null
 * @returns The mapped PlayerAction or null
 */
export function mapTransitionToAction(
  transitionType: string | null
): PlayerAction | null {
  if (transitionType == null) return null;
  return TRANSITION_TYPE_MAP[transitionType] ?? null;
}
